import { lightTheme, Colors } from '@unmind/design-system/theme/deprecated';
import { GridColumns, GridGutters, GridMargins } from './grid';
import ZIndex from './zIndex';

export const defaultTheme = {
  ...lightTheme,
  grid: {
    columns: GridColumns,
    gutters: GridGutters,
    margins: GridMargins,
  },
  zIndex: ZIndex,
  colors: {
    ...lightTheme.colors,
    multiSelect: {
      multiValue: {
        backgroundColor: lightTheme.colors.form.field.background,
      },
      multiValueRemove: {
        backgroundColor: lightTheme.colors.form.field.background,
        focused: {
          backgroundColor: lightTheme.colors.form.dropdown.remove,
        },
      },
      option: {
        hover: {
          backgroundColor:
            lightTheme.colors.form.dropdown.option.background.focus,
        },
        active: {
          backgroundColor:
            lightTheme.colors.form.dropdown.option.background.focus,
        },
        backgroundColor:
          lightTheme.colors.form.dropdown.option.background.default,
      },
    },
    chatbot: {
      logo: {
        primary: '#FFCF26', // @TODO: Move this to the design system theme
        secondary: '#F0A378', // @TODO: Move this to the design system theme
        tertiary: '#2D150D', // @TODO: Move this to the design system theme
      },
      messages: {
        user: {
          background: Colors.neutralDark200,
        },
        input: {
          background: Colors.white,
        },
        loading: {
          bubbles: Colors.glassDark500,
        },
      },
    },
    login: {
      text: Colors.gray8,
      panel: Colors.gray2,
      border: Colors.gray9,
    },
    index: {
      bands: {
        low: Colors.sentimentOrange200,
        mid: Colors.blue700,
        high: Colors.sentimentGreen200,
      },
    },
    mood: {
      saddest: Colors.sentimentOrange200,
      sadder: '#FDBD43',
      sad: '#FFD78A',
      neutral: '#86B6FF',
      happy: '#72F270',
      happier: '#5EDB5C',
      happiest: Colors.sentimentGreen200,
      border: Colors.brown500,
    },
    signup: {
      privacyBackground: Colors.negroni,
      privacyIconForeground: Colors.gray9,
      privacyIconBackground: Colors.orange9,
    },
    start: {
      aboutBackground: Colors.hummingBirdBlue,
      iconForeground: Colors.gray9,
      iconBackground: Colors.aqua5,
    },
    welcome: {
      topBackground: Colors.yellow1,
      bottomBackground: Colors.white,
      iconForeground: Colors.gray9,
      iconBackground: Colors.yellow3,
    },
    series: {
      search: {
        background: Colors.gray2,
      },
    },
    mediaPlayer: {
      audio: {
        icon: {
          default: Colors.glassDark900,
          hover: Colors.glassDark700,
          background: Colors.glassDark200,
        },
        backButton: {
          hover: Colors.glassDark100,
        },
        borderFocus: Colors.blue700,

        animation: {
          page: Colors.cream100,

          bg_1: Colors.yellow500,
          stroke_1: Colors.brown500,

          bg_2: Colors.lilac200,
          stroke_2: Colors.brown500,

          bg_3: Colors.blue200,
          stroke_3: Colors.brown500,

          bg_4: Colors.cream500,
          stroke_4: Colors.brown500,

          bg_5: Colors.kiwi200,
          stroke_5: Colors.brown500,
        },
      },
    },

    meta: {
      theme: Colors.cream100,
      tile: Colors.brown500,
      icon: Colors.yellow500,
    },
  },
};

type defaultThemeType = typeof defaultTheme;

export type ThemeInterface = defaultThemeType;

export type MoodColors = ThemeInterface['colors']['mood'];

export default defaultTheme;
